import React from "react";

import campaignStepOneIcon from "../../assets/images/svg/mab-compgn-1.svg";
import dropOpenIcon from "../../assets/images/svg/mab-drop-open-1.svg";
import downArrow from "../../assets/images/svg/mab-down-arrow.svg";
import ellipseBg from "../../assets/images/svg/mab-ellipse.svg";
import NextButton from "../common/next-button";

type MusicDropdownProps = {
  id: string;
  expandedId: string | null;
  onToggle: (id: string) => void;
  onNext?: (id: string) => void;
  spotifyUrl: string;
  artistName: string;
  title: string;
  showAdditionalFields: boolean;
  onSpotifyUrlChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onArtistNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTitleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEditMode?: boolean;
};

const MusicDropdown: React.FC<MusicDropdownProps> = ({
  id,
  expandedId,
  onToggle,
  onNext,
  spotifyUrl,
  artistName,
  title,
  showAdditionalFields,
  onSpotifyUrlChange,
  onArtistNameChange,
  onTitleChange,
  isEditMode = false,
}) => {
  const isOpen = expandedId === id;

  return (
    <div className="w-full">
      <div
        className="relative rounded-[20px] shadow-[0_14px_40px_rgba(0,0,0,0.25)] overflow-hidden"
        style={{
          borderRadius: "20px",
          background: "#878DA11A",
          backgroundImage: `url(${ellipseBg})`,
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="flex items-center gap-3 cursor-pointer hover:opacity-90 transition-opacity"
          style={{
            height: "88px",
            padding: "24px",
          }}
          onClick={() => onToggle(id)}
        >
          <div className="flex items-center gap-3 flex-1">
            <img src={isOpen ? dropOpenIcon : campaignStepOneIcon} alt="Step 1" className="w-8 h-8" />
            <span
              style={{
                fontFamily: "Poppins",
                fontWeight: 400,
                fontStyle: "normal",
                fontSize: "20px",
                lineHeight: "130%",
                letterSpacing: "0%",
                textAlign: "center",
                color: isOpen ? "#58F2A9" : "#FFFFFF",
              }}
            >
              Music
            </span>
          </div>
          <img
            src={downArrow}
            alt="Toggle"
            className="pointer-events-none transition-transform"
            style={{
              height: "9.5px",
              width: "auto",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              filter: isOpen
                ? "brightness(0) saturate(100%) invert(78%) sepia(89%) saturate(1352%) hue-rotate(90deg) brightness(102%) contrast(101%)"
                : "none",
            }}
          />
        </div>

        {isOpen && (
          <div
            className="flex flex-col gap-6  ml-10 pb-6 items-start"
            style={{
              paddingLeft: "24px",
              paddingRight: "24px",
              paddingBottom: "24px",
            }}
          >
            <div className="w-full">
              <label
                className="text-left"
                style={{
                  color: "#FFFFFF",
                  fontSize: "16px",
                  fontWeight: 400,
                  fontStyle: "normal",
                  lineHeight: "130%",
                  letterSpacing: "0%",
                }}
              >
                Add your Spotify song URL
              </label>
              <input
                type="text"
                placeholder="https://open.spotify.com/track/...."
                value={spotifyUrl}
                onChange={onSpotifyUrlChange}
                disabled={isEditMode}
                className="bg-white rounded-[12px] focus:outline-none focus:ring-2 focus:ring-[#58F2A9] w-full mt-[8px]"
                style={{
                  height: "45px",
                  paddingTop: "6px",
                  paddingRight: "16px",
                  paddingBottom: "6px",
                  paddingLeft: "16px",
                  borderRadius: "12px",
                  opacity: isEditMode ? 0.6 : 1,
                  maxWidth: "100%",
                  fontSize: "0.8rem",
                  backgroundColor: isEditMode ? "#f0f0f0" : "white",
                  cursor: isEditMode ? "not-allowed" : "text",
                }}
              />
            </div>

            {showAdditionalFields && (
              <div className="flex flex-col lg:flex-row gap-6 w-full">
                <div className="flex flex-col gap-2 flex-1 min-w-0">
                  <label
                    className="[font-family:'Poppins',Helvetica] text-left"
                    style={{
                      color: "#FFFFFF",
                      fontSize: "16px",
                      fontWeight: 400,
                      fontStyle: "normal",
                      lineHeight: "130%",
                      letterSpacing: "0%",
                    }}
                  >
                    Enter artist name
                  </label>
                  <input
                    type="text"
                    placeholder="Artist name"
                    value={artistName}
                    onChange={onArtistNameChange}
                    className="bg-white rounded-[12px] focus:outline-none focus:ring-2 focus:ring-[#58F2A9] w-full"
                    style={{
                      height: "45px",
                      paddingTop: "6px",
                      paddingRight: "16px",
                      paddingBottom: "6px",
                      paddingLeft: "16px",
                      borderRadius: "12px",
                      opacity: 1,
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      fontSize: "0.8rem",
                    }}
                  />
                </div>

                <div className="flex flex-col gap-2 flex-1 min-w-0">
                  <label
                    className="[font-family:'Poppins',Helvetica] text-left"
                    style={{
                      color: "#FFFFFF",
                      fontSize: "16px",
                      fontWeight: 400,
                      fontStyle: "normal",
                      lineHeight: "130%",
                      letterSpacing: "0%",
                    }}
                  >
                    Enter title
                  </label>
                  <input
                    type="text"
                    placeholder="Song title"
                    value={title}
                    onChange={onTitleChange}
                    className="bg-white rounded-[12px] focus:outline-none focus:ring-2 focus:ring-[#58F2A9] w-full"
                    style={{
                      height: "45px",
                      paddingTop: "6px",
                      paddingRight: "16px",
                      paddingBottom: "6px",
                      paddingLeft: "16px",
                      borderRadius: "12px",
                      opacity: 1,
                      maxWidth: "100%",
                      boxSizing: "border-box",
                      fontSize: "0.8rem",
                    }}
                  />
                </div>
              </div>
            )}

            <div className="flex justify-end w-full">
              <NextButton size="sm" onClick={() => onNext && onNext(id)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MusicDropdown;

